import { render, staticRenderFns } from "./ear_tag.vue?vue&type=template&id=3a40fc7a"
import script from "./ear_tag.vue?vue&type=script&lang=js"
export * from "./ear_tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports